import T from 'prop-types';
import React, { Component } from 'react';
import { Record } from 'immutable';
import { Box, Loader, TextInput, FormField } from '@acast/decibel';
import isValidEmail from 'shared/helpers/is-valid-email';
import findUserByEmail from 'shared/components/admin-tools/helpers/find-user-by-email';

const SearchState = Record({
  email: '',
  valid: false,
  user: null,
  fetchUser: null,
  error: null,
});

class UserSearchInput extends Component {
  static propTypes = {
    onUserFound: T.func.isRequired,
    onUserNotFound: T.func.isRequired,
    disabled: T.bool.isRequired,
  };

  state = {
    search: new SearchState(),
  };

  onUserSearchResponse = (err, user) => {
    if (err) {
      this.props.onUserNotFound();
    } else {
      this.props.onUserFound(user);
    }
    this.updateState({
      error: err,
      user,
      fetchUser: null,
    });
  };

  setEmail = ({ target: { value } }) => {
    this.props.onUserNotFound();
    this.updateState({
      email: value,
      valid: isValidEmail(value),
      error: null,
      user: null,
    });
  };

  getInputAddon(search) {
    if (search.fetchUser) {
      return (
        <TextInput.Addon>
          <Box height="100%" alignItems="center" justifyContent="center" pr={2}>
            <Loader width={8} />
          </Box>
        </TextInput.Addon>
      );
    }

    return null;
  }

  updateState(deltaState) {
    this.setState(({ search }) => {
      if (search.fetchUser !== null) {
        search.fetchUser.abort();
      }
      let nextSearch = search.merge(deltaState).merge({
        fetchUser: null,
      });
      if (nextSearch.valid && nextSearch.user === null) {
        nextSearch = nextSearch.merge({
          fetchUser: findUserByEmail(nextSearch.email, this.onUserSearchResponse),
        });
      }
      return {
        search: nextSearch,
      };
    });
  }

  render() {
    const { search } = this.state;
    const { disabled } = this.props;

    return (
      <FormField
        label="Search for user by email address:"
        invalid={!!search.error}
        helperText={search.error ? 'Invalid user' : null}
      >
        <TextInput
          placeholder="Enter email address"
          value={search.email}
          disabled={disabled}
          onChange={this.setEmail}
          addonEnd={this.getInputAddon(search)}
        />
      </FormField>
    );
  }
}

export default UserSearchInput;
